module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-notificator-wrapper"
  }, [(_vm.itemsCount > 1) ? _c('font-awesome-icon', {
    staticClass: "w5-notification-close-all-button",
    attrs: {
      "icon": "times-circle"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeAll($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "w5-notificator"
    }
  }, [(_vm.ticketView) ? _c('div', {
    key: "ticketView",
    staticClass: "w5-notification cursor-pointer-default",
    class: _vm.ticketView.class ? _vm.ticketView.class : false
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "notif-close-button",
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeSpecialNotification('view')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("ftc")(_vm.ticketView.title)))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.ticketView.message),
      expression: "ticketView.message"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ticketPost) ? _c('div', {
    key: "ticketPost",
    staticClass: "w5-notification cursor-pointer-default ticket-post",
    class: _vm.ticketPost.class ? _vm.ticketPost.class : false
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "notif-close-button",
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeSpecialNotification('post')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("ftc")(_vm.ticketPost.title)))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.ticketPost.message),
      expression: "ticketPost.message"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(notification, idx) {
    return _c('div', {
      key: notification.key,
      staticClass: "w5-notification",
      class: notification.class ? notification.class : false,
      style: (notification.id === 'success-message' ? 'cursor: default' : false),
      on: {
        "click": function($event) {
          return _vm.goTo(notification, $event)
        }
      }
    }, [_c('button', {
      staticClass: "close",
      attrs: {
        "id": "notif-close-button",
        "title": _vm._f("ftc")('main/close')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.remove(notification)
        }
      }
    }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("ftc")(notification.title)))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding": "0",
        "margin": "0"
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(notification.message)))]), _vm._v(" "), (idx === 0 && notification.id !== 'success-message') ? [_c('font-awesome-icon', {
      staticClass: "w5-notification-volume-button pull-right",
      attrs: {
        "id": "notif-volume-button",
        "icon": _vm.whatVolume ? 'volume-up' : 'volume-mute'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setVolume($event)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "clearfix"
    })] : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('audio', {
    ref: "audioNotif_00",
    attrs: {
      "src": "/static/snd/notif.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_01",
    attrs: {
      "src": "/static/snd/notif01.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_02",
    attrs: {
      "src": "/static/snd/notif02.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    ref: "audioNotif_03",
    attrs: {
      "src": "/static/snd/notif03.mp3"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5271b432"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/notificator.vue
// module id = 781
// module chunks = 0